
export enum ReportPayTypeEnum
{
    Balance = 1,
    Visa = 2,
    ApplePay = 3,
    NewLeap = 4,
    SurePay = 5,
    InterSoft = 6,
    CashBack = 7

}